import { useCallback, useState } from "react";
import { find, isNil } from "lodash";
import { AiccLanguageStatus } from "constants/aiccLanguage";
import { AiccLessonEntryApi } from "types/model/aiccLearningAssets";
import { saveFile } from "utils/saveFile";
import { useLearningAssetsStore } from "../../useLearningAssetsStore";

interface Options {
  api: AiccLessonEntryApi;
  exportName: string;
  languageId?: number;
  groupStatus?: AiccLanguageStatus;
}

export function useLessonEntryExport({ api, exportName, languageId, groupStatus }: Options) {
  const languageName = useLearningAssetsStore((store) => find(store.languages, { id: store.languageId })?.name);
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback(() => {
    if (isNil(languageId) || isNil(groupStatus)) {
      return;
    }
    setIsDownloading(true);
    api
      .exportFile(languageId, groupStatus)
      .then((content) => saveFile(content, `${languageName ?? languageId}_${exportName}_${groupStatus}.xlsx`))
      .catch(() => undefined)
      .finally(() => setIsDownloading(false));
  }, [api, exportName, groupStatus, languageId, languageName]);

  return { isDownloading, download };
}
